// ute 2.0
// Device detection and responsive library

// Set Environment Vars
if (!uteRogers) { // Provided from portal
  var uteRogers = {
    'environment': {
      'province': window.__userPref.province,
      'language': window.__userPref.language,
      'loginState': window.__userInfo.uuid ? 'post' : 'pre'
    }
  };
}

var _ute = {}; // global var
_ute.version = '1.1';
_ute.settingsDefault = {};
_ute.settingsDefault.fixed = '';
_ute.settingsDefault.center = false;
_ute.settingsDefault.width = {};
_ute.settingsDefault.orientation = {};
_ute.settingsDefault.hd = {'pixelRatio': 1.1, 'modifyAllImgSrc': true};
_ute.settingsDefault.viewport = {'width': 'device-width', 'initial': 1.0, 'max': 2.0, 'scalable': true};
_ute.settingsDefault.url = {};
//_ute.settingsDefault.url.content = '/cms/ute-pages/dynamic/content/';
_ute.settingsDefault.url.content = {};
_ute.settingsDefault.url.content.html = '/cms/ute-pages/homepage/data/';
_ute.settings = _ute.settingsDefault;
_ute.widthOld = 'default';
_ute.widthNew = 'default';
_ute.numberSlides = 1;
_ute.sliderMode = 'fade';
_ute.device = {};
_ute.device.info = '';
_ute.device.family = '';
_ute.device.touchEnabled = false;
_ute.device.mobile = false;
_ute.device.tablet = false;
_ute.device.iphone = false;
_ute.device.ipad = false;
_ute.device.ipod = false;
_ute.device.apple = false;
_ute.device.android = false;
_ute.device.blackberry = false;
_ute.device.windows = false;
_ute.device.type = '';
_ute.device.name = '';
_ute.device.browserVersion = '';
_ute.device.orientation = '';
_ute.device.width = 0;
_ute.device.size = 'lg'; //default
_ute.device.sizeOld = 'lg'; //default
_ute.device.height = 0;
_ute.device.pixelRatio = 1;
_ute.component = {}; //Gets populated with array of component html templates
_ute.object = {};
_ute.content = {};
_ute.content.environment = uteRogers.environment;
_ute.content.data = {};
_ute.content.template = {};
_ute.content.template.container = '';
_ute.content.template.component = '';
_ute.content.template.provinces = ['ab', 'bc', 'mb', 'nb', 'nl', 'ns', 'on', 'pe', 'qc', 'sk'];
_ute.menu = '';
_ute.page = '';
_ute.event = {}; // Contains all ute related events
_ute.event.uteWindowResize = $.Event('uteWindowResize');
_ute.event.uteInspectComponents = $.Event('uteInspectComponents');
_ute.event.uteLanguageChange = $.Event('uteLanguageChange');
_ute.event.uteProvinceChange = $.Event('uteProvinceChange');
_ute.event.uteMenuToggle = $.Event('uteMenuToggle');
_ute.event.utePageChange = $.Event('utePageChange');

//** DETECT HTML UPDATES VIA JQUERY - to trigger uteInspectComponents event (START) **//
// Create a new ute event to be triggered when page html content is altered by jQuery using:
// $.html(), $.append(), $.prepend(), $.before() or $.after()
// to allow scan of document for newly injected ute components. ToDo: $.clone(), $.ajax()
$(document).ajaxComplete(function (event, xhr, settings) {
  if (!settings.url.search('.template.')) { // ** TODO: Need a better component differentiators
    console.log('ajax call completed');
    $(document).trigger(_ute.event.uteInspectComponents);
  }
});

(function ($, oldHtmlMethod) {
  $.fn.html = function () {
    var results = oldHtmlMethod.apply(this, arguments);
    //com.invisibility.elements.findAndRegisterElements(this);
    $(document).trigger(_ute.event.uteInspectComponents);
    return results;
  };
})(jQuery, jQuery.fn.html);

(function ($, oldAppendMethod) {
  $.fn.append = function () {
    var results = oldAppendMethod.apply(this, arguments);
    $(document).trigger(_ute.event.uteInspectComponents);
    return results;
  };
})(jQuery, jQuery.fn.append);

(function ($, oldPrependMethod) {
  $.fn.prepend = function () {
    var results = oldPrependMethod.apply(this, arguments);
    $(document).trigger(_ute.event.uteInspectComponents);
    return results;
  };
})(jQuery, jQuery.fn.prepend);

(function ($, oldBeforeMethod) {
  $.fn.before = function () {
    var results = oldBeforeMethod.apply(this, arguments);
    $(document).trigger(_ute.event.uteInspectComponents);
    return results;
  };
})(jQuery, jQuery.fn.before);

(function ($, oldAfterMethod) {
  $.fn.after = function () {
    var results = oldAfterMethod.apply(this, arguments);
    $(document).trigger(_ute.event.uteInspectComponents);
    return results;
  };
})(jQuery, jQuery.fn.after);
//** DETECT HTML UPDATES VIA JQUERY - to trigger uteInspectComponents event (END) **//

var uteBindWindowResize = function () {
  $(window).bind('resize', function () {
    window.resizeEvt;
    $(window).resize(function () {
      clearTimeout(window.resizeEvt);
      window.resizeEvt = setTimeout(function () {
        uteUpdate();
      }, 500);
    });
  });
};

var uteLoadObjects = function () {
  $('.ute-object').each(function () {
    _ute.object[$(this).attr('id')] = $(this).html();
  });
  $('.ute-object').remove();
};

var utePopulateDynamicContent = function () {
  _ute.content.template.container = '<div class="ute-items"></div>';
  _ute.content.template.component = '<div class="item"><div class="ute ute-component-[componentType]" data-component="[componentType]" data-content="[componentSource]"><img class="ute-image1 img-responsive lazyOwl" alt="[altText]" src="..." /><div class="ute-content-con"><div class="ute-title">[title]</div><div class="ute-description">[content]</div><a class="ute-cta" href="javascript: void(0);" title="">[cta name]</a></div></div></div>';
  $('.ute-con[data-content*="."], .ute-con [data-content*="."]').each(function () {
    uteGetDynamicContent($(this));
  });
};

var uteUpdate = function () {
  uteUpdateDeviceSize();
  uteUpdateCenter();
  uteUpdateOrientation();
  uteUpdateWidth();
  //uteUpdateComponents();
};

var uteUpdateDeviceSize = function () {
  _ute.device.width = $(window).width();
  _ute.device.height = $(window).height();

  _ute.device.sizeOld = _ute.device.size;
  if (_ute.device.width <= 320) {
    _ute.device.size = 'xs';
  } else if (_ute.device.width <= 480) {
    _ute.device.size = 'sm';
  } else if (_ute.device.width <= 767) {
    _ute.device.size = 'md';
  } else if (_ute.device.width <= 979) {
    _ute.device.size = 'lg';
  } else if (_ute.device.width <= 1200) {
    _ute.device.size = 'xl';
  }
  //else {
  //  _ute.device.size = 'xxl';
  //}_ute.device.width >= 600ƒ

  // dynamic meta tags
  if ($.restive.isPhone()){
    $('#deviceViewport').attr('content', 'width=device-width,initial-scale=1');

  } else if ($.restive.isTablet()) {

    if($.restive.isIOS()){
      $('#deviceViewport').attr('content', 'width=1200,maximum-scale=1,user-scalable=no');
    }
    else
    {
      $('#deviceViewport').attr('content', 'maximum-scale=1');
    }

  }

  $(window).trigger(_ute.event.uteWindowResize);
  //$('body').attr('ute-device-size', _ute.device.size);
  // uteToggleMenu();
};

var uteUpdateHD = function (dom) {
  var domSelector;
  if (typeof dom != 'undefined') {
    domSelector = $(dom).find('img');
  } else {
    if (_ute.settings.hd.modifyAllImgSrc) {
      domSelector = '.ute-con img';
    } else {
      domSelector = '.ute-con img[class*=ute-image]';
    }
  }
  if (uteDeviceIsHD()) {
    $('body').addClass('hd');
    $(domSelector).each(function () {
      var src = $(this).attr('src');
      if (src.indexOf('@hd') < 0) {
        var extension = src.substring(src.lastIndexOf('.'), src.length);
        $(this).attr('src', src.replace(extension, '@hd' + extension));
      }
    });
  } else {
    $('body').removeClass('hd');
    $(domSelector).each(function () {
      var src = $(this).attr('src');
      if (src.indexOf('@hd') < 0) {
        $(this).attr('src', src.replace('@hd', ''));
      }
    });
  }
};

var uteDeviceIsHD = function () {
  var isHD = false;
  if (_ute.settings.hd.pixelRatio > 0 && _ute.device.pixelRatio >= _ute.settings.hd.pixelRatio) {
    isHD = true;
  }
  return isHD;
};

var uteUpdateCenter = function () {
  $('.ute-con').css({
    'margin': 0,
    'padding': 0,
    'width': 'auto'
  });
  if (_ute.settings.center) {
    $('.ute-con').addClass('ute-center');
  } else {
    $('ute-con').removeClass('ute-center');
  }
};

var uteUpdateOrientation = function () {
  if ($(window).height() > $(window).width()) {
    $('body').removeClass('landscape').addClass('portrait');
    _ute.device.orientation = 'portrait';
  } else {
    $('body').removeClass('portrait').addClass('landscape');
    _ute.device.orientation = 'landscape';
  }
};

var uteUpdateWidth = function () {
  $('html').css({
    'width': '100%',
    'margin': '0 0',
    'transform': 'none',
    '-ms-transform': 'none',
    '-webkit-transform': 'none'
  });
  if (_ute.settings.fixed) {
    $('body').addClass('fixed');
    $('li.ute-row > *').width(_ute.settings.fixed);
    $('li.ute-row-bg > *').not('h2').width('100%');
  } else {
    $('body').removeClass('fixed');
    $('li.ute-row > *').width('');
    _ute.device.width = $(window).width();
    _ute.device.height = $(window).height();
    _ute.widthOld = _ute.widthNew;
    $('body').addClass('default');
    _ute.widthNew = 'default';
    for (var key in _ute.settings.width) {
      if (_ute.settings.width.hasOwnProperty(key)) {
        if (_ute.device.width >= _ute.settings.width[key].min && _ute.device.width <= _ute.settings.width[key].max) {
          $('body').removeClass('default').addClass(key);
          _ute.widthNew = key;
          if (_ute.settings.width[key].fixed == 'min') {
            $('li.ute-row > *').width(_ute.settings.width[key].min);
            $('li.ute-row-bg > *').not('h2').width('100%');
          } else if (_ute.settings.width[key].fixed == 'max') {
            $('li.ute-row > *').width(_ute.settings.width[key].max);
            $('li.ute-row-bg > *').not('h2').width('100%');
          } else if (_ute.settings.width[key].fixed == 'scale') {
            $('li.ute-row > *').width(_ute.settings.width[key].min);
            $('li.ute-row-bg > *').not('h2').width('100%');
            var scale = _ute.device.width / _ute.settings.width[key].min;
            var pageHeight = $('html').height();
            var pageWidth = $('html').width();
            var marginVertical = ((pageHeight * scale) - pageHeight) / 2;
            var marginHorizontal = ((pageWidth * scale) - pageWidth) / 2;
            $('html').css({
              'width': _ute.settings.width[key].min + 'px',
              'margin': marginVertical + 'px ' + marginHorizontal + 'px',
              'transform': 'scale(' + scale + ')',
              '-ms-transform': 'scale(' + scale + ')',
              '-webkit-transform': 'scale(' + scale + ')'
            });
          }
        } else {
          $('body').removeClass(key);
        }
      }
    }
  }
};

var uteMobileCheck = function () {
  return (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(webOS)|(BlackBerry)|(BB10)|(Windows Phone)/i)) ? true : false;
};

var uteDetectDevice = function () {

  // fixed responsive layout in mobile ie10
  //if (navigator.userAgent.match(/IEMobile\/10\.0/)) {

  //}


  $('#header').removeClass('no-js');
  var classes = '';
  _ute.device.info = navigator.userAgent.toLowerCase();
  _ute.device.utesupported=true;

  if (_ute.device.info.search('apple') > 0) {
    _ute.device.family = 'apple';
    _ute.device.apple = true;

  }
  if (_ute.device.info.search('android') > 0) {
    _ute.device.family = 'android';
    _ute.device.android = true;
    _ute.device.apple = false;
  } else if (_ute.device.info.search('blackberry') > 0 || _ute.device.info.search('bb10') > 0) { // bb is bb10 + other new BB phones
    _ute.device.family = 'blackberry';
    _ute.device.blackberry = true;
    _ute.device.apple = false;
  } else if (_ute.device.info.search('iemobile') > 0) {
    _ute.device.family = 'windowsmobile';
    _ute.device.windows = true;
    _ute.device.mobile = true;
    _ute.device.utesupported=false;
    var msViewportStyle = document.createElement('style');
    msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
    document.getElementsByTagName('head')[0].appendChild(msViewportStyle);
  } else if (_ute.device.info.search('windows') > 0) {
    _ute.device.family = 'windows';
    _ute.device.windows = true;
    _ute.device.apple = false;
    if (_ute.device.info.search('safari') > 0) {
      _ute.device.name = 'safari';
    }
    if (_ute.device.info.search('firefox') > 0) {
      _ute.device.name = 'firefox';
    } else if (_ute.device.info.search('chrome') > 0) {
      _ute.device.name = 'chrome';
    } else if (_ute.device.info.search('opera') > 0) {
      _ute.device.name = 'opera';
    } else if (isIEBrowser()) {
      _ute.device.name = 'internet-explorer';
      _ute.device.browserVersion = getIEVersion();
    }
  }
  if (uteMobileCheck()) {
    _ute.device.mobile = true;
    _ute.numberSlides = 3;
    _ute.sliderMode = 'horizontal';
    if (_ute.device.info.search('apple') > 0) {
      if (_ute.device.info.search('iphone') > 0) {
        _ute.device.iphone = true;
        _ute.device.type = 'phone';
        _ute.device.name = 'iphone';
      }
      if (_ute.device.info.search('ipad') > 0) {
        _ute.device.ipad = true;
        _ute.device.tablet = true;
        _ute.device.type = 'tablet';
        _ute.device.name = 'ipad';
      }
      if (_ute.device.info.search('ipod') > 0) {
        _ute.device.ipod = true;
        _ute.device.type = 'other';
        _ute.device.name = 'ipod';
      }
    } else if (_ute.device.info.search('android') > 0) {
      if (_ute.device.info.search('android') && _ute.device.info.search('mobile') > 0) {
        _ute.device.type = 'phone';
      } else {
        _ute.device.tablet = true;
        _ute.device.type = 'tablet';
      }
    } else if (_ute.device.info.search('blackberry') > 0 || _ute.device.info.search('bb10') > 0) { // bb is bb10 + other new BB phones
      if (_ute.device.info.search('mobile') > 0) {
        _ute.device.type = 'phone';
        _ute.device.name = 'bb';
      }
      if (_ute.device.info.search('playbook') > 0) {
        _ute.device.tablet = true;
        _ute.device.type = 'tablet';
        _ute.device.name = 'playbook';
      }
    } else if (_ute.device.info.search('windows') > 0) {
      if (_ute.device.info.search('windows') > 0 && _ute.device.info.search('(khtml, like gecko)') > 0) {
        _ute.device.type = 'phone';
      } else {
        _ute.device.tablet = true;
        _ute.device.type = 'tablet';
      }
    }
  }

  var url = window.location.href;
  // if ((url.search('RogersServices.portal') < 0) && ((typeof Modernizr != 'undefined' && Modernizr.touch) || _ute.device.mobile)) {
  if ((typeof Modernizr !== 'undefined' && Modernizr.touch) || _ute.device.mobile) {
    _ute.device.touchEnabled = true;
    classes = 'touchenabled';

    if( _ute.device.utesupported===false)
    {
      classes += ' ute-incompatible-device';
    }
    if (_ute.device.mobile) {
      classes += ' mobile ' + _ute.device.type + ' ' + _ute.device.family + ' ' + _ute.device.name;
    }
  } else {
    classes = 'desktop ' + _ute.device.family + ' ' + _ute.device.name + ' ver-' + _ute.device.browserVersion;
  }

  if (window.devicePixelRatio === undefined) {
    _ute.device.pixelRatio = 1;
  } else {
    _ute.device.pixelRatio = window.devicePixelRatio;
    _ute.device.pixelRatio = Number(_ute.device.pixelRatio) >= 3 ? 3 : Math.ceil(_ute.device.pixelRatio);
  }

  uteUpdateDeviceSize();

  //classes += ' pixelratio-' + _ute.device.pixelRatio.toString().replace('.', '-');
  $('body').addClass(classes).attr('ute-pixel-ratio', _ute.device.pixelRatio);
};

var uteGetDevicePixelRatio = function () {
  if (window.devicePixelRatio === undefined) {
    return 1;
  }
  return window.devicePixelRatio;
};

var uteShowDeviceInfo = function () {
  var url = window.location.href;
  if (url.search('showdevice') > 0) {
    /*
    if(family='windowsmobile') {
      var iehead = $('head');
    }
    else{
      iehead = 'n/a';
    }
    */
    alert('DEVICE INFO (USERAGENT):\n' + _ute.device.info + '\n\n<body class=\'' + $('body').attr('class') + '\' ute-pixel-ratio=\'' + $('body').attr('ute-pixel-ratio') + '\' ute-device-size=\'' + $('body').attr('ute-device-size') + '\'>\n\nDEVICE TYPE IDENTIFIERS\nTouch Enabled: ' + _ute.device.touchEnabled + '\nType: ' + _ute.device.type + '\nMobile: ' + _ute.device.mobile + '\nTablet: ' + _ute.device.tablet + '\n\nDEVICE NAMES\nFamily: ' + _ute.device.family + '\nName: ' + _ute.device.name + '\nBrowserVersion(IE): ' + _ute.device.browserVersion + '\niPhone: ' + _ute.device.iphone + '\niPad: ' + _ute.device.ipad + '\niPod: ' + _ute.device.ipod + '\n\nFAMILY IDENTIFIERS\nApple: ' + _ute.device.apple + '\nAndroid: ' + _ute.device.android + '\nBlackBerry: ' + _ute.device.blackberry + '\nWindows: ' + _ute.device.windows + '\n\nDEVICE RESOLUTION & ORIENTATION\nOrientation: ' + _ute.device.orientation + '\nResolution (Width): ' + _ute.device.width + '\nResolution (Height): ' + _ute.device.height + '\nPixel Ratio: ' + _ute.device.pixelRatio + '\nDevice Size: ' + _ute.device.size)/* + '\nHead: ' + iehead*/;

  }
};

var isIEBrowser = function () {
  return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})').exec(navigator.userAgent) !== null)));
};

var getIEVersion = function () {
  var rv = -1,
    ua,
    re;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    ua = navigator.userAgent;
    re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
    if (re.exec(ua) !== null)
      rv = parseFloat(RegExp.$1);
  } else if (navigator.appName === 'Netscape') {
    ua = navigator.userAgent;
    re = new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
    if (re.exec(ua) !== null)
      rv = parseFloat(RegExp.$1);
  }
  return rv;
};

/**
 *
 * @param language
 */
var uteToggleLanguage = function (language) {
  console.log('uteToggleLanguage');
  var selectedLanguage = language ? language : (_ute.content.environment.language == 'en' ? 'fr' : 'en');
  console.log('selectedLanguage', selectedLanguage);
  if (selectedLanguage !== _ute.content.environment.language) {
    _ute.content.environment.language = selectedLanguage;
    $(window).trigger(_ute.event.uteLanguageChange);
  }
};

$(window).on('uteLanguageChange', function () {
  console.log('window uteLanguageChange');
  $('body, html').attr('ute-language', _ute.content.environment.language);
  $('[ute-language-selector]').attr('ute-language-selector', _ute.content.environment.language);
  console.log('uteLanguageChange Event Triggered: ' + _ute.content.environment.language);
});

/**
 *
 * @param province
 */
var uteProvinceChange = function (province) {
  var selectedProvince = province ? province : $('.province-selector').val();
  if (selectedProvince !== _ute.content.environment.province) {
    _ute.content.environment.province = selectedProvince;
    $(window).trigger(_ute.event.uteProvinceChange);
  }
};

$(window).on('uteProvinceChange', function () {
  $('body').attr('ute-province', _ute.content.environment.province);
  $('[ute-province-selector]').attr('ute-province-selector', _ute.content.environment.province);
  console.log('uteProvinceChange Event Triggered: ' + _ute.content.environment.province);
});

/**
 *
 * @param page
 */
var uteGotoPage = function (page) {
  $('[ute-page].active:not(body)').removeClass('active jumpInUp');
  _ute.page = page || '';
  $('[ute-page=' + _ute.page + ']:not(body)').addClass('active jumpInUp');
  $(window).trigger(_ute.event.utePageChange);
};

$(window).on('utePageChange', function () {
  $('body').attr('ute-page', _ute.page);
  console.log('utePageChange Event Triggered: ' + _ute.page);
});

var uteInit = function (settingsUser) {
  if (settingsUser) {
    $.extend(_ute.settings, _ute.settingsDefault, settingsUser);
  }
  uteBindWindowResize();
  uteDetectDevice();
  uteShowDeviceInfo();
  uteUpdate();
  uteUtils();
};

$(document).ready(function () {

  // $('body')
  //   // .attr('ute-language', _ute.content.environment.language)
  //   // .attr('ute-login-state', _ute.content.environment.loginState)
  //   // .attr('ute-province', _ute.content.environment.province);

  uteInit({
    'center': true,
    'width': {
      'narrow': {
        'min': 0,
        'max': 767,
        'fixed': ''
      },
      'wide': {
        'min': 1025,
        'max': 100000,
        'fixed': 'min'
      }
    }
  });

  uteUpdateHD();

});
